import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export function useWorkspaceFolderNavigation() {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentPath = searchParams.get("path") ?? "";

  const segments = useMemo(() => {
    if (!currentPath) return [];
    return currentPath.split("/").filter(Boolean);
  }, [currentPath]);

  const pushSegment = useCallback(
    (folder: string) => {
      const next = currentPath ? `${currentPath}${folder}/` : `${folder}/`;
      setSearchParams((prev) => {
        const next2 = new URLSearchParams(prev);
        next2.set("path", next);
        return next2;
      });
    },
    [currentPath, setSearchParams],
  );

  const navigateToPath = useCallback(
    (path: string) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        if (path) {
          next.set("path", path);
        } else {
          next.delete("path");
        }
        return next;
      });
    },
    [setSearchParams],
  );

  const popToIndex = useCallback(
    (index: number) => {
      if (index < 0) {
        navigateToPath("");
        return;
      }
      const newPath = segments.slice(0, index + 1).join("/") + "/";
      navigateToPath(newPath);
    },
    [segments, navigateToPath],
  );

  return {
    currentPath,
    segments,
    pushSegment,
    popToIndex,
    navigateToPath,
  };
}
